import HelperNumber from "../helpers/HelperNumber";
import { regex } from "../utils/regex";

// Máscaras disponíveis
const Mask = {
    cpf: (value: string | null | undefined) => {
        if (value === null || value === undefined)
            return value;
        return value
            .replace(regex.notDigitRegex, '')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})/, '$1-$2')
            .replace(/(-\d{2})\d+?$/, '$1');
    },
    cnpj: (value: string | null | undefined) => {
        if (value === null || value === undefined)
            return value;
        return value
            .replace(regex.notDigitRegex, '')
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1/$2')
            .replace(/(\d{4})(\d)/, '$1-$2')
            .replace(/(-\d{2})\d+?$/, '$1');
    },
    cpfOrCnpj: (value: string | null | undefined) => {
        if (value === null || value === undefined)
            return value;
        const cleaned = value.replace(regex.notDigitRegex, '');
        return cleaned.length <= 11 ? Mask.cpf(value) : Mask.cnpj(value);
    },
    phone: (value: string | null | undefined) => {
        if (value === null || value === undefined || checkPhoneComplet(value))
            return value;
        return value
            .replace(regex.notDigitRegex, '')
            .replace(/^(\d{2})(\d)/g, '($1) $2')
            .replace(/(\d)(\d{4})$/, '$1-$2');
    },
    zipcode: (value: string | null | undefined) => {
        if (value === null || value === undefined || checkCEPComplet(value))
            return value;
        return value
            .replace(regex.notDigitRegex, '')
            .replace(/^(\d{5})(\d)/, '$1-$2')
            .replace(/(-\d{3})\d+?$/, '$1');
    },
    currencyMask: (value: string | null | undefined) => {
        if (value === null || value === undefined)
            return value;

        let justNumber = HelperNumber.justNumber(value ?? '')
        
        if (justNumber.length > 3) {
            justNumber = justNumber.replace(/^0/, '')
        } else if(justNumber.length === 2) {
            justNumber = justNumber.replace(/^00/, '0')
        } 

        return justNumber
            .replace(/(\d)(\d{2})$/, '$1,$2')
            .replace(/(?=(\d{3})+(\D))\B/g, '.');
    },
    date: (value: string | null | undefined) => {
        if (value === null || value === undefined || checkDateComplet(value)) {
            return value;
        }
        let cleaned = value.replace(regex.notDigitRegex, '');
        if (cleaned.length > 2) {
            cleaned = cleaned.replace(/^(\d{2})/, '$1/');
        }
        if (cleaned.length > 5) {
            cleaned = cleaned.replace(/^(\d{2})\/(\d{2})/, '$1/$2/');
        }
        if (cleaned.length > 10) {
            cleaned = cleaned.substring(0, 10);
        }
        return cleaned;
    },
    onlyNumbers: (value: string | null | undefined) => {
        if (value === null || value === undefined) {
            return value;
        }
        return value.replace(regex.notDigitRegex, '');
    },
    proposalNumber: (value: string | null | undefined) => {
        if (value === null || value === undefined) return value;

        const numericPart = value.replace(regex.notDigitRegex, '').substring(0, 6);

        return `P-${numericPart}`;
    }
};

const checkDateComplet = (str: string) => {
    return (str?.split('/')?.length ?? 0) >= 3;
};

const checkCEPComplet = (str: string) => {
    return (str?.split('-')?.length ?? 0) >= 2;
};

const checkPhoneComplet = (str: string) => {
    return (str?.split('-')?.length ?? 0) >= 2 && (str?.split('-')[0].length ?? 0) >= 10;
};

export default Mask;